import React, { useCallback, useRef, useState } from "react";
import { NavLink } from "reactstrap";
import { useDocumentCapturePhaseListener } from "Hooks/useDocumentCapturePhaseListener";

export default function EmailsMenu({
  children
}: {
  children?: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRootRef = useRef<HTMLDivElement | null>(null);

  const handleDocumentClick = useCallback((e: MouseEvent | TouchEvent) => {
    const container = menuRootRef.current;
    if (!container) {
      return;
    }
    const t = e.target;
    if (
      t instanceof Node &&
      (container.contains(t) || container === t)
    ) {
      return;
    }
    setIsOpen(false);
  }, []);

  useDocumentCapturePhaseListener(isOpen, handleDocumentClick);

  const toggle = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpen(o => !o);
  }, []);

  return (
    <div
      ref={menuRootRef}
      className={`emails-menu ${isOpen ? "shown" : ""}`}
    >
      {children}

      <NavLink
        className="emails-menu-button d-inline-block d-xl-none"
        onClick={toggle}
      >
        <i className="fa fa-chevron-right" />
      </NavLink>
    </div>
  );
}
